import React, { useState } from "react";
import { Form, Input, Select, InputNumber, Button, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const { TextArea } = Input;

export const LineForm = ({ form, onFinish, typeLines }) => {
  const [, setForceUpdate] = useState({});

  const getSelectedTypes = () => form.getFieldValue("line_details") || [];

  const availableTypes = typeLines.filter(
    (type) =>
      !getSelectedTypes().find((selected) => selected.type_line_id === type.id)
  );

  const handleAddType = () => {
    const values = form.getFieldValue("newType");
    if (values?.type_line_id && values?.num_stations) {
      const currentTypes = getSelectedTypes();
      form.setFieldValue("line_details", [
        ...currentTypes,
        {
          type_line_id: values.type_line_id,
          num_stations: values.num_stations,
        },
      ]);
      form.setFieldValue("newType", {
        type_line_id: undefined,
        num_stations: undefined,
      });
      setForceUpdate({});
    }
  };

  const handleRemoveType = (type_line_id) => {
    const currentTypes = getSelectedTypes();
    form.setFieldValue(
      "line_details",
      currentTypes.filter((t) => t.type_line_id !== type_line_id)
    );
    setForceUpdate({});
  };

  const handleFormSubmit = (values) => {
    if (values.line_details && values.line_details.length > 0) {
      onFinish(values);
    } else {
      message.error("Veuillez sélectionner au moins un type");
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFormSubmit}
      className="space-y-4"
    >
      <Form.Item
        name="name"
        label="Nom de la ligne"
        rules={[
          { required: true, message: "Veuillez entrer le nom de la ligne" },
        ]}
      >
        <Input placeholder="Entrez le nom de la ligne" />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <TextArea rows={4} placeholder="Entrez la description de la ligne" />
      </Form.Item>

      <Form.Item name="line_details" hidden>
        <Input />
      </Form.Item>

      <div className="mb-4">
        <label className="block mb-2 font-medium">Types sélectionnés</label>
        <div className="space-y-2">
          {getSelectedTypes().map((type) => (
            <div
              key={type.type_line_id}
              className="flex items-center gap-4 p-2 bg-gray-50 rounded"
            >
              <span>
                {typeLines.find((t) => t.id === type.type_line_id)?.name}
              </span>
              <span>{type.num_stations} places</span>
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleRemoveType(type.type_line_id)}
                className="ml-auto"
              />
            </div>
          ))}
        </div>
      </div>

      {availableTypes.length > 0 && (
        <div className="border p-4 rounded">
          <label className="block mb-2 font-medium">Ajouter un type</label>
          <Form.Item noStyle>
            <div className="flex gap-4">
              <Form.Item
                name={["newType", "type_line_id"]}
                className="mb-0 flex-1"
              >
                <Select placeholder="Sélectionnez un type">
                  {availableTypes.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name={["newType", "num_stations"]} className="mb-0">
                <InputNumber
                  min={1}
                  placeholder="Nombre de places"
                  className="w-32"
                />
              </Form.Item>

              <Button type="primary" onClick={handleAddType}>
                +
              </Button>
            </div>
          </Form.Item>
        </div>
      )}
    </Form>
  );
};
